<template>
    <!-- 个人中心首页 -->
  <div class="my-center">

    <!-- 推币 -->
    <pack class="money-info">
      <el-row class="header">
        当前推币
        <span>总数(个)</span>
      </el-row>
      <el-row class="align-center">
        <span class="money">{{money_total}}</span>
        <app-link to="/my-center/rechange">
          <zt-button class="pay" size="small" round>去充值</zt-button>
        </app-link>
      </el-row>
      <app-link to="/my-center/tui-coin" class="look">查看明细></app-link>
    </pack>

    <!-- tabs -->
    <pack>
      <zt-title>我的信息</zt-title>
      <el-tabs @tab-click="onTabChange" :value="current">
        <el-tab-pane label="认证资料">
            <Datum />
        </el-tab-pane>
        <el-tab-pane label="个人信息">
          <Nom-Info />
        </el-tab-pane>
        <el-tab-pane label="账号安全">
          <Safe />
        </el-tab-pane>
      </el-tabs>
    </pack>
  </div>
</template>

<script>
import Datum from './tabs/index/Datum'
import NomInfo from './tabs/index/NomInfo'
import Safe from './tabs/index/Safe'
import { mapGetters } from 'vuex'

export default {
  components: {
    Datum,
    NomInfo,
    Safe,
  },
  name: 'myCenter',
  data: () => ({
    money: 0,
  }),
  computed: {
    ...mapGetters(['user_info' ]),
    
    money_total() {
      return this.user_info.money_total
    },

    current() {
      return this.$store.state.tabs.myCenterTabs
    },
  },
  created() {
    this.money = this.$store.state.user.info.money;
    if(this.$route.query.current == 1) {
      this.$store.dispatch('ChangeTabs', { name: 'myCenterTabs', current: this.$route.query.current+''})
    }
  },
  methods: {
    onTabChange(e) {
      console.log(e.index)
      this.$store.dispatch('ChangeTabs', { name: 'myCenterTabs', current: e.index })
    },
  },
  
}
</script>

<style lang="scss" scoped>
.my-center {
  position: relative;
  .money-info {
    color: $theme-white;
    background: linear-gradient(135deg, $theme 0%, rgba(125, 138, 255, 1) 100%);
    .header {
      line-height: 25px;
      font-size: 18px;
      margin-bottom: 10px;
      span {
        font-size: 12px;
        margin-left: 4px;
      }
    }
    .align-center {
      display: flex;
      align-items: center;
    }
    .money {
      font-size: 40px;
      font-weight: 600;
      margin-right: 24px;
    }
    .pay {
      background-color: transparent;
      color: $theme-white;
    }
    .look {
      position: absolute;
      top: 32px;
      right: 24px;
      font-size: 12px;
      line-height: 17px;
    }
  }
}
</style>